<template>
  <!-- content works -->
  <div class="landing-works">
    <section class="content-works">
      <div class="inside">
        <div
          class="text-center headline-container"
          v-if="pageInclusionCaseStudies.header_text"
        >
          <h1 class="headline" v-in-viewport="{}">
            {{ pageInclusionCaseStudies.header_text.value }}
          </h1>
          <p
            class="intro_text"
            v-in-viewport="{}"
            v-if="pageInclusionCaseStudies.intro_paragraph"
          >
            {{ pageInclusionCaseStudies.intro_paragraph.value }}
          </p>
        </div>

        <boxes-wrapper :boxes="caseStudies" :boxlimit="8"></boxes-wrapper>
      </div>
    </section>
  </div>
</template>

<script>
import apiConnection from "../mixins/apiConnection.js";
import seoModule from "../mixins/seoModule.js";
import boxesWrapperInclusion from "../components/boxes-wrapper-inclusion.vue";

export default {
  name: "InclusionCaseStudies",
  data() {
    return {
      caseStudies: [],
      pageInclusionCaseStudies: [],
    };
  },
  created: function () {
    this.getInclusionCaseStudies(1000);

    window.addEventListener("resize", this.handleResize);
  },
  components: {
    "boxes-wrapper": boxesWrapperInclusion,
  },
  mixins: [apiConnection, seoModule],
  methods: {},
  mounted() {
    this.$gtm.trackView("Inclusion Case Studies", "Inclusion");
    setTimeout(function () {
      $(".st-sticky-share-buttons").removeClass("st-sticky-share-buttons-show");
    }, 500);
  },
  computed: {},
};
</script>



// WEBPACK FOOTER //
// InclusionCaseStudies.vue?b24d3dae